import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=2e865226&scoped=true"
import script from "./OkModal.vue?vue&type=script&lang=ts"
export * from "./OkModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e865226",
  null
  
)

export default component.exports